import { redirect } from 'react-router';

import type { JobPost } from '~/api/jobPosts/types';
import type { Params } from '~/providers/RouterProvider/router.types';

import { HttpForbiddenError, HttpNotFoundError } from '~/api/errors';
import { jobPostQueryOptions } from '~/api/jobPosts/useJobPost';
import { queryClient } from '~/providers/QueryClientProvider/queryClient';
import { routes } from '~/providers/RouterProvider/router.routes';

export const loader = async ({ params }: { params: Params<typeof routes.showJobPost> }): Promise<JobPost> => {
  const jobPostId = Number(params.jobPostId);

  try {
    return await queryClient.ensureQueryData(jobPostQueryOptions(jobPostId));
  } catch (error) {
    if (error instanceof HttpNotFoundError || error instanceof HttpForbiddenError) {
      throw redirect(routes.jobPosts);
    }

    throw error;
  }
};
